<template>
  <PopupTips :list :popupIcon position="right" :z-index="102" :animateIcon="true">
    <div class="activityTips">
      <div class="content">
        <div class="item" v-for="(item, i) in list" @click="gotoActivity(item, $router)" :key="i">
          <Image :src="item.menuLogo" class="size-9" alt="" />
          <div class="flex-1 pl-2">
            <div><span class="text-[#FFDF12] bold-[600] text-11">{{item.activityConfigLogo}}</span></div>
            <div v-if="item.amount"><span class="bold-[600] text-17 mr-1">{{ formatter().format(item.amount) }}</span>R$</div>
          </div>
          <img src="@a/assets/images/bn_rec.png" class="size-14 mr-0.5" alt="" />
        </div>
      </div>
    </div>
  </PopupTips>
</template>

<script setup lang="ts">
  import PopupTips from '@a/components/popupTips/index.vue'
  import popupIcon from '@a/assets/images/popup_r.png'

  import { formatter, gotoActivity } from '@/utils';
  import { useActivityList } from '@/store'

  const activityList = computed(() => useActivityList().activityList)
  const list = computed(() => activityList.value.filter(item => item.showRedPoint))
</script>

<style lang="scss" scoped>
.activityTips{
  @apply w-[327px] pt-[118px];

  &::before{
    @apply bgs-[url('@a/assets/images/bg_activity_popup.png')] wh-[279px_192px] absolute-center-x top-0 content-[''];
  }

  .content{
    @apply bg-gradient-to-b from-[#FFFAD8] to-[#E5FFBC] rounded-[16px] pt-17 pb-6;

    .item{
      @apply h-16 pl-[25px] bg-gradient-to-b from-[#6BCA24] to-[#41AE26] bd-[2px_white] rounded-full m-[20px_15px_auto] flex-center-y;
    }
  }
}
</style>
